import { z } from 'zod';

const battleSchema = z
  .object({
    battleTickSeconds: z.number().positive(),
    battleStartGlobalCdSeconds: z.number().nonnegative(),
    mainCdBaseSpeedMultiplier: z.number().nonnegative(),
    minMainCdSeconds: z.number().nonnegative(),
    maxMainCdSeconds: z.number().nonnegative(),
    ultaPassiveChargePerSecond: z.number().nonnegative(),
    ultaChargePerMain: z.number().nonnegative(),
    ultaChargePerSecondary: z.number().nonnegative(),
    ultaChargePerDamageTakenPercent: z.number().nonnegative(),
    switchCooldownSeconds: z.number().nonnegative(),
    damageRandMin: z.number().nonnegative(),
    damageRandMax: z.number().nonnegative(),
    criticalHitChance: z.number().min(0).max(1),
    criticalHitMultiplier: z.number().nonnegative(),
    stab: z.number().nonnegative(),
  })
  .superRefine((data, ctx) => {
    if (data.minMainCdSeconds > data.maxMainCdSeconds) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'minMainCdSeconds must be <= maxMainCdSeconds',
        path: ['minMainCdSeconds'],
      });
    }
    if (data.damageRandMin > data.damageRandMax) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'damageRandMin must be <= damageRandMax',
        path: ['damageRandMin'],
      });
    }
  });

const mapSchema = z.object({
  tickIntervalSeconds: z.number().nonnegative(),
  encounterChancePerTick: z.number().min(0).max(1),
});

const catchSchema = z.object({
  shakeCount: z.number().int().nonnegative(),
  shakeMs: z.number().nonnegative(),
  statusBonusSleep: z.number().nonnegative(),
  statusBonusFreeze: z.number().nonnegative(),
  statusBonusBurnPoisonParalysis: z.number().nonnegative(),
  statusBonusNone: z.number().nonnegative(),
});

const xpSchema = z.object({
  perWildVictory: z.number().int().nonnegative(),
  perTrainerVictory: z.number().int().nonnegative(),
  perGymVictory: z.number().int().nonnegative(),
});

const inventoryEntrySchema = z.object({
  itemId: z.string().min(1),
  quantity: z.number().int().positive(),
});

const newGameSchema = z.object({
  starterSpeciesIds: z.array(z.string().min(1)).min(1),
  starterLevel: z.number().int().min(1).max(100),
  startingCurrency: z.number().int().nonnegative(),
  startingInventory: z.array(inventoryEntrySchema),
});

export const balanceSchema = z.object({
  $schemaVersion: z.number().int().positive(),
  battle: battleSchema,
  map: mapSchema,
  catch: catchSchema,
  xp: xpSchema,
  newGame: newGameSchema,
});

export type Balance = z.infer<typeof balanceSchema>;
